function applySeatSnapToFabricObject(obj, snap) {
    obj.set({ left: snap.left, top: snap.top, radius: snap.radius });
    return snap;
}

function applyFurnitureSnapToFabricObject(obj, snap) {
    obj.gridX = snap.gridX;
    obj.gridY = snap.gridY;
    obj.widthCells = snap.widthCells;
    obj.heightCells = snap.heightCells;
    obj.set({
        left: snap.left,
        top: snap.top,
        width: snap.width,
        height: snap.height,
        scaleX: 1,
        scaleY: 1
    });
    if (obj._lastValid) {
        obj._lastValid.left = obj.left;
        obj._lastValid.top = obj.top;
        obj._lastValid.width = obj.width;
        obj._lastValid.height = obj.height;
        obj._lastValid.scaleX = obj.scaleX;
        obj._lastValid.scaleY = obj.scaleY;
        obj._lastValid.fill = obj.fill;
    }
    return {
        left: snap.left,
        top: snap.top,
        width: snap.width,
        height: snap.height
    };
}

module.exports = {
    applySeatSnapToFabricObject: applySeatSnapToFabricObject,
    applyFurnitureSnapToFabricObject: applyFurnitureSnapToFabricObject
};
